import { ts } from 'src/utils/translate';
import { useResetCustomItemMutation } from "src/api/v1/quote-ApiSlice";

export const ResetButton = (props: any) => {
  const { table, row, currency, dispatchDownloadStates } = props;

  const [ resetCustomItem ] = useResetCustomItemMutation()

  return row.edited_buy_user === true ? (
    <span className="resetContainer">
      &nbsp;
      <span style={{ color: "#70747b", margin: "0 5px 0 10px" }}>{ts("edited", "Edited")}</span>
      <button
        onClick={() => resetCustomItem(row.custom_item_id)}
        className="btn blue-uplan lightershadow btn-xs"
      >
        {ts("reset", "Reset").toUpperCase()}
      </button>
    </span>
  ) : null;
};
